<template>
  <client-only>
    <div class="resultsLoader text-center">
      <img src="../../static/loader.png" alt="טעינה" />
    </div>
  </client-only>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.resultsLoader img {
  width: 50px;
  animation: spin 1.5s infinite linear;
  margin: 20px auto;
}

/* results loading */
@keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
</style>
